
class DatepickerInlineSelectors {

    getComponentSelector(element)
    {
        return '.datepicker_inline_component';
    }


    getDateInputSelector()
    {
        return `.connected_date_input`;
    }

    getCalendarSelector()
    {
        return `.calendar`;
    }

}

